import { CaseEditingSessionDto } from '@peritasai/types';

/**
 * Represents a backend editing session that locks a case while the cart is being built.
 */
export class CaseEditingSessionEntity {
  public readonly caseId?: string;
  public readonly userId?: string;
  public readonly userInitials?: string;
  public readonly startedAt: Date;
  public readonly lastActivity: Date;
  public readonly expiresAt: Date;

  constructor(dto: CaseEditingSessionDto) {
    this.caseId = dto.caseId;
    this.userId = dto.userId;
    this.userInitials = dto.userInitials;
    this.startedAt = new Date(dto.startedAt);
    this.lastActivity = new Date(dto.lastActivity);
    this.expiresAt = new Date(dto.expiresAt);
  }

  static fromDTO(dto: CaseEditingSessionDto): CaseEditingSessionEntity {
    return new CaseEditingSessionEntity(dto);
  }

  toDTO(): CaseEditingSessionDto {
    return {
      caseId: this.caseId,
      userId: this.userId,
      userInitials: this.userInitials,
      startedAt: this.startedAt.toISOString(),
      lastActivity: this.lastActivity.toISOString(),
      expiresAt: this.expiresAt.toISOString(),
    };
  }

  /**
   * Returns true when the session expiry timestamp has passed.
   */
  get isExpired(): boolean {
    return Date.now() >= this.expiresAt.getTime();
  }

  /**
   * Milliseconds remaining before the session expires (clamped to zero).
   */
  get msUntilExpiry(): number {
    return Math.max(0, this.expiresAt.getTime() - Date.now());
  }
}
